module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content h-full"
  }, [_c('div', {
    staticClass: "app-content-body app-content-full",
    staticStyle: {
      "bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs"
  }, [_c('div', {
    staticClass: "layout-callcenter"
  }, [_c('call-center-map', {
    ref: "map",
    attrs: {
      "reboques": _vm.reboques
    }
  }), _vm._v(" "), _c('btn-atendimento', {
    on: {
      "click": function($event) {
        _vm.openAtendimento = !_vm.openAtendimento
      }
    }
  }), _vm._v(" "), _c('atendimento', {
    attrs: {
      "opened": _vm.openAtendimento,
      "patios": _vm.patios,
      "categoria": _vm.categorias,
      "agentes": _vm.agentes
    },
    on: {
      "close": function($event) {
        _vm.openAtendimento = false
      },
      "novoAtendimento": _vm.novoAtendimento,
      "atualizaAtendimento": _vm.atualizaAtendimento,
      "geocodeAddress": _vm.geocodeAddress
    }
  }), _vm._v(" "), _c('tickets-ativos', {
    attrs: {
      "remocoes": _vm.remocoes
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f61a5e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/Main.vue
// module id = 1746
// module chunks = 17